module.exports = __webpack_public_path__ + "img/playstore.3f5b91c4.png";